import { bookServiceApi } from '@/services/api';

export interface CharacterAnalysisItem {
  section_number: number;
  analysis_text: string;
  status: 'unlocked' | 'locked' | string;
}

export interface CharacterAnalysisCharacter {
  character_name: string;
  character_icon: string;
  progress_percentage: number;
  analyses: CharacterAnalysisItem[];
}

export interface CharacterAnalysisResponse {
  data: {
    characters: CharacterAnalysisCharacter[];
  };
  is_premium: boolean;
}

export const getCharacterAnalysis = async (bookId: number, isSpoil = false): Promise<CharacterAnalysisResponse> => {
  const res = await bookServiceApi.get<CharacterAnalysisResponse>(`/novel/books/${bookId}/character-analysis?is_spoil=${isSpoil}`);
  if (res.success && res.data) {
    return res.data;
  }
  throw new Error(res.error || 'Failed to fetch character analysis');
};

